import $axios from "@/plugins/axios";

const baseurl = "https://reyee.ruijie.com.cn/bida/faq/";
const baseNewUrl =
  "https://reyee.ruijie.com.cn/llmopsprod/wiki-api/queryWikiForMacc/";
const searchurl = "https://reyee.ruijie.com.cn/llmopsprod/wiki-api/search_doc";

$axios.postRequest = (url, data, loading = false) => {
  let params = {
    ContentType: "application/json",
    params: JSON.stringify(data),
  };
  return Promise.resolve(
    $axios.post(url, params, {
      loading,
    }),
  );
};

$axios.getRequest = (url) => {
  return Promise.resolve($axios.get(url));
};

// 接口
// 0、请求文章内容的json的url
export function getJSON(url) {
  return $axios.getRequest(url);
}
// 1、请求分类
export function categories(id) {
  let url = baseurl + "directories?id=1";
  return $axios.getRequest(url);
}
// 1、请求分类
export function categories2() {
  let url = baseurl + "directories?id=2";
  return $axios.getRequest(url);
}
export function categoriesSmart(id) {
  let url = baseNewUrl + id;
  return $axios.getRequest(url);
}
// 2、请求文章
export function articles(id) {
  let url = baseurl + "content?id=" + id;
  return $axios.getRequest(url);
}
// 3、请求文章
export function queryArticleList(keyword) {
  let url = searchurl + "?wikiId=1,2&keyword=" + keyword;
  return $axios.getRequest(url);
}
